module.exports = __webpack_public_path__ + "static/media/E_Mobility_Payal.a0237ce7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/E_Mobility_Payal.webp
// module id = 351
// module chunks = 0